import { ROUTES } from "../routes";

const PARAMETERIZED_ROUTE_BASES = [
    ROUTES.INVOICE_PAY.urlPath,
    ROUTES.PUBLIC_FORM.urlPath,
    ROUTES.TELEHEALTH.urlPath,
    ROUTES.TELEHEALTH_PLUS.urlPath,
    ROUTES.REGISTRATION.urlPath,
    ROUTES.LOGIN.urlPath,
];

/**
 * Collapses tenant GUID and dynamic route segments into stable RUM page IDs.
 * Aligns with parameterized routes in ClientPortalRouter.
 */
export function normalizeClientPortalPageUrl(pathname: string, clientPortalGuid: string): string {
    const withoutGuid = pathname.replace(`/clientportal/${clientPortalGuid}`, "/clientportal");

    for (const base of PARAMETERIZED_ROUTE_BASES) {
        if (withoutGuid.startsWith(`/clientportal/${base}/`)) {
            return `/clientportal/${base}`;
        }
    }

    return withoutGuid;
}
